import React, { useState } from "react";
import PropTypes from "prop-types";
import { Button, SelectField } from "react-md";
import ContentEditable from "react-contenteditable";

export const NOTE_INTERNAL = "NOTE_INTERNAL";
export const NOTE_EXTERNAL = "NOTE_EXTERNAL";
const noteTypeOptions = [
  { label: "Internal", value: NOTE_INTERNAL },
  { label: "External", value: NOTE_EXTERNAL }
];

const NoteInputField = props => {
  const [noteType, setNoteType] = useState(noteTypeOptions[0].value);
  const [noteText, setNoteText] = useState(props.note ?? null);
  
  
  const textChangeHandler = event => {
    let newText = event.target?.value || event.target?.textContent || "";
    setNoteText(newText);
  };

  const onSaveNote = () => {
    props.showNoteType
      ? props.saveNote(noteText, noteType)
      : props.saveNote(noteText);
    setNoteText(null);
    if (props.showNoteType){
      setNoteType(noteTypeOptions[0].value);
    }
  };

  let textBoxCellStyle = props.showNoteType ? "md-cell--9 " : "md-cell--11 ";
  let dropdownCellStyle = props.showAsDialog ? "md-cell--3" : "md-cell--2";

  return (
    <>
    {noteType.value === NOTE_EXTERNAL && <div className="note-input-field-warning">Warning: External notes are visible to all users</div>}
      <div className="md-grid note-input-field-container" style={{ width: "100%" }}>
        <div
          className={textBoxCellStyle + (noteText ? "content-editable-placeholder-disabled" : "content-editable-placeholder-enabled")}
          style={{ position: "relative" }}
        >
          <p className="case-history-input-placeholder">{props.placeholder}</p>
          <ContentEditable
            id="content-editable"
            className={"content-editable"}
            onChange={e => textChangeHandler(e)}
            html={noteText ?? ""}
            style={{
              maxHeight: "300px",
              minHeight: props.showAsDialog ? 130 : 65,
              width: "100%"
            }}
            />
        </div>
        {props.showNoteType && <div className={`${dropdownCellStyle} note-type-dropdown-container`}>
          <SelectField 
            menuItems={noteTypeOptions}
            onChange={setNoteType}
            value={noteType}
          />
        </div>}
        <div className={props.showAsDialog ? "" : "md-cell--1"}>
          <Button
            onClick={onSaveNote}
            primary
            raised
            disabled={!noteText}
            type="submit"
            children={props.saveButtonLabel ? props.saveButtonLabel : "Save"}
            className="case-history-input-field-button"
          />
        </div>
        {props.onCancel && <div className={props.showAsDialog ? "" : "md-cell--1"}>
          <Button
            onClick={props.onCancel}
            raised
            type="cancel"
            children="Cancel"
            className="case-history-input-field-button"
          />
          </div>}
      </div>
    </>
  );
};

NoteInputField.propTypes = {
  note: PropTypes.string, // Note text
  setNote: PropTypes.func,  // Set note text in parent state
  saveNote: PropTypes.func, // Save note, this is called with the noteText. If showNoteType = true, this will be called with the noteType value as the 2nd argument
  placeholder: PropTypes.string,  // Placeholder text to display in empty text box
  showNoteType: PropTypes.bool, // Show choice to choosing internal or external note
  showAsDialog: PropTypes.bool, // When true, styles are updated to better accomodate dialog format
  onCancel: PropTypes.func, // If provided, cancel button is shown (for use as dialog)
  saveButtonLabel: PropTypes.string,  // Optional, overrides "Save" as button label
};

export default NoteInputField;
